var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBludDrop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C6.43128 2.30545 0 12 0 15.9597C0 20.3933 3.58891 24 8 24C12.4111 24 16 20.393 16 15.9597C16 11.999 9.56862 2.30555 8 0ZM8 21.8328C7.76931 21.8328 7.58275 21.6453 7.58275 21.4134C7.58275 21.1816 7.76931 20.9941 8 20.9941C10.7624 20.9941 13.0101 18.735 13.0101 15.9587C13.0101 15.7269 13.1967 15.5394 13.4274 15.5394C13.6581 15.5394 13.8447 15.7269 13.8447 15.9587C13.8447 19.1987 11.2228 21.8328 8 21.8328Z",
    fill: "#647EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBludDrop);
export default __webpack_public_path__ + "static/media/bludDrop.b8389b5f75eddc847fc27e23aec8bb4d.svg";
export { ForwardRef as ReactComponent };